export default "__VITE_ASSET__2a483703__"